module.exports = __webpack_public_path__ + "assets/img/map_track.171984d8.png";